import React, { useContext } from 'react';
import { Form } from 'antd';
import DatePicker from './DatePicker.js';
import dayjs from 'dayjs';
import { ThemeContext } from 'styled-components';
import { DatePickerSearchMLStyled } from './DatePickerSearchMLStyled';
import { BrandContext } from '@/contexts/ContextProviders';
import './index.less';
import classnames from 'classnames';

/**
 * 头部OK按钮
 * @param {*} param
 */
const DatePickerML = ({
  labelVal,
  placeVal,
  icon,
  height,
  labelwidth,
  inputWidth,
  maxWidth,
  name,
  required = [],
  className = [],
  disabled,
}) => {
  const themeContext = useContext(ThemeContext);
  const brandContext = useContext(BrandContext);

  const handleOk = (e) => {
    console.log(dayjs(e.$d).format('YYYY-MM-DD HH:mm:ss'));
  };
  return (
    <DatePickerSearchMLStyled
      theme={themeContext}
      brand={brandContext}
      inputWidth={inputWidth}
      maxWidth={maxWidth}
      height={height}
      labelwidth={labelwidth}
    >
      <Form.Item
        className={classnames(...className)}
        colon={false}
        name={name}
        rules={required}
        label={
          <>
            {icon ? icon : ''}
            {labelVal}
          </>
        }
      >
        <DatePicker
          placeholder={placeVal}
          disabled={disabled}
          showTime={{ format: 'HH:mm:ss' }}
          format="YYYY-MM-DD HH:mm:ss"
          onOk={handleOk}
        />
      </Form.Item>
    </DatePickerSearchMLStyled>
  );
};

export default DatePickerML;
